import { useContext } from 'react'
import { SimpleAdminAuthContext } from '@/contexts/SimpleAdminAuthContext'

export function useSimpleAdminAuth() {
  const context = useContext(SimpleAdminAuthContext)

  if (!context) {
    throw new Error('useSimpleAdminAuth must be used within a SimpleAdminAuthProvider')
  }

  return context
}
